import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useDogs } from '@/composables/useDogs'
import { DogBreedDto, DogDto, DogFoodAllergenDto, DogFoodTypeDto, DogHealthIssueDto } from '@lyka-pet-food/contracts'

export const useAnimalsStore = defineStore('animals', () => {
  const dogs = ref<DogDto[]>([])
  const breeds = ref<DogBreedDto[]>([])
  const healthIssues = ref<DogHealthIssueDto[]>([])
  const foodTypes = ref<DogFoodTypeDto[]>([])
  const foodAllergens = ref<DogFoodAllergenDto[]>([])
  const loading = ref(false)

  const loadDogs = async () => {
    const { returnedDogs, error } = await useDogs().getDogs()

    // TODO: Move to error  handling
    if (error) {
      console.error(error)
      return
    }

    if (returnedDogs) {
      dogs.value = returnedDogs.filter((d) => !d.deactivatedAt)
    }
  }

  const loadDogsData = async () => {
    const { data, error } = await useDogs().getDogsData()

    // TODO: Move to error  handling
    if (error) {
      console.error(error)
      return
    }

    if (data) {
      breeds.value = data.breeds
      healthIssues.value = data.healthIssues
      foodTypes.value = data.foodTypes
      foodAllergens.value = data.foodAllergens
    }
  }

  const load = async () => {
    loading.value = true
    await Promise.all([loadDogs(), loadDogsData()])
    loading.value = false
  }

  const getDogById = (petId: string) => {
    return dogs.value?.find((animal) => animal.id === petId)
  }

  const getAllergenById = (id: string) => {
    return foodAllergens.value?.find((i) => i.id === id)
  }

  const getFoodTypeById = (id: string) => {
    return foodTypes.value?.find((i) => i.id === id)
  }

  const getHealthIssueById = (id: string) => {
    return healthIssues.value?.find((i) => i.id === id)
  }

  const getAllergenBySlug = (slug: string) => {
    return foodAllergens.value?.find((i) => i.slug === slug)
  }

  const getFoodTypeBySlug = (slug: string) => {
    return foodTypes.value?.find((i) => i.slug === slug)
  }

  const getHealthIssueBySlug = (slug: string) => {
    return healthIssues.value?.find((i) => i.slug === slug)
  }

  const breedsToSelectOptions = () => {
    return breeds.value
      ?.map((opt) => {
        return {
          text: opt.name,
          value: opt.slug,
        }
      })
      .sort((a, b) => a.text.localeCompare(b.text))
  }

  return {
    getDogById,
    getAllergenById,
    getFoodTypeById,
    getHealthIssueById,
    getAllergenBySlug,
    getFoodTypeBySlug,
    getHealthIssueBySlug,
    breedsToSelectOptions,
    load,
    loadDogs,
    loading,
    dogs,
    breeds,
    healthIssues,
    foodTypes,
    foodAllergens,
  }
})
